import _CardHeader from "@mui/material/CardHeader";
import _Card from "@mui/material/Card";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { ArrivalIcon, DepartureIcon, StepIcon } from '../icons';
function WayPointCard({
  isArrival,
  bikeStationsMap,
  route: {
    wayPoints,
    sections
  },
  sectionIndex
}) {
  const {
    t
  } = useTranslation();
  const section = sections[sectionIndex];
  const departure = wayPoints[sectionIndex];
  const arrival = wayPoints[wayPoints.length - 1];
  const prevSection = sections[sectionIndex - 1];
  const bikeStations = 'bikeStations' in section && section.bikeStations || undefined;
  const departureBikeStation = bikeStations ? bikeStations.from : prevSection && 'bikeStations' in prevSection && prevSection.bikeStations?.to || undefined;
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: isArrival ? 'arrival' : '',
    elevation: 0
  }, /*#__PURE__*/React.createElement(StyledHeader, {
    avatar: isArrival ? /*#__PURE__*/React.createElement(ArrivalIcon, null) : sectionIndex === 0 ? /*#__PURE__*/React.createElement(DepartureIcon, null) : /*#__PURE__*/React.createElement(StepIcon, null),
    className: isArrival ? 'arrival' : sectionIndex === 0 ? 'departure' : '',
    subheader: isArrival ? arrival.addressDetail?.secondaryText : departureBikeStation ? departure.address : departure.addressDetail?.secondaryText,
    title: isArrival ? arrival.addressDetail?.primaryText : departureBikeStation ? t('commons.routing.roadmap.bike_station_name', {
      name: bikeStationsMap[departureBikeStation.bikeStationId]?.name || ''
    }) : departure.addressDetail?.primaryText
  }));
}
const Wrapper = styled(_Card)`
  && {
    background-color: transparent;

    &.arrival {
      margin-top: 24px;
    }
  }
`;
const StyledHeader = styled(_CardHeader)`
  &.departure {
    align-items: flex-start;
  }

  &.arrival {
    align-items: flex-end;
  }

  .MuiCardHeader-avatar {
    height: 24px;
    z-index: 2;
  }

  .MuiCardHeader-title {
    font-size: 1.1em;
  }
`;
export default WayPointCard;